import { useState } from "react";
import { motion } from "framer-motion";

const faqData = [
  { question: "What is the loan application process?", answer: "The loan application process includes submitting an online form, providing necessary documents, and waiting for approval." },
  { question: "What are the eligibility criteria?", answer: "Eligibility criteria include a stable income, good credit history, and being at least 18 years old." },
  { question: "How long does approval take?", answer: "Approval typically takes between 24 to 72 hours depending on the verification process." },
  { question: "What are the repayment options?", answer: "Repayment options include monthly EMIs, direct debit, or manual payments via the online portal." },
  { question: "Can I prepay my loan?", answer: "Yes, you can prepay your loan. Some loans may have prepayment penalties, so check your loan terms." },
];

export default function FaqLoansSmco() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <motion.div
      className="faq-container-smco"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={{ visible: { transition: { staggerChildren: 0.4 } } }}
    >
      <motion.h2 
        className="faq-title-smco"
        variants={{
          hidden: { opacity: 0, y: 20 },
          visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
        }}
      >
        FAQ - Magnify Advaisory 
      </motion.h2>

      <motion.div className="faq-list-smco">
        {faqData.map((item, index) => (
          <motion.div
            key={index}
            className="faq-item-smco"
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
            }}
          >
            <button className="faq-question-smco" onClick={() => toggleFAQ(index)}>
              {item.question}
              <motion.i
                className={`faq-icon-smco fa ${openIndex === index ? "fa-chevron-up" : "fa-chevron-down"}`}
              ></motion.i>
            </button>
            <motion.div
              className={`faq-answer-smco ${openIndex === index ? "open" : ""}`}
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: openIndex === index ? "auto" : 0, opacity: openIndex === index ? 1 : 0 }}
              transition={{ duration: 0.4 }}
            >
              {item.answer}
            </motion.div>
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
}
